import { HStack } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

const OptionOneWayQuotation = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleChange = (): void => {
    sgwtWebAnalytics?.trackEvent(
      'Header',
      'user preferences, option tab, option one way quotation',
      String(!userPreferences.optionOneWayQuotation),
    );
    updateUserPreferences({ ...userPreferences, optionOneWayQuotation: !userPreferences.optionOneWayQuotation });
  };

  return (
    <div className="d-flex align-items-center justify-content-between p-3 px-4 border-bottom">
      <label htmlFor="option-one-way-quotation">
        <FormattedMessage id="userPreferences.label.optionOneWayQuotation" />
      </label>
      <HStack className="form-check-sm form-check-valid form-switch" data-e2e="optionOneWayQuotation">
        <input
          id="option-one-way-quotation"
          className="form-check-input me-8px"
          type="checkbox"
          checked={userPreferences.optionOneWayQuotation}
          onChange={handleChange}
          data-e2e={'optionOneWayQuotation-checkbox'}
        />
        <span>
          <FormattedMessage id={`switchInput.${userPreferences.optionOneWayQuotation ? 'on' : 'off'}`} />
        </span>
      </HStack>
    </div>
  );
};

export default OptionOneWayQuotation;
